import { LANDING_LOCALIZED_PATHS } from './publicHeader.constants';

export const landingLocale = (): 'en' | 'pl' =>
	(localStorage.getItem('lang') || 'pl') === 'pl' ? 'pl' : 'en';

const landingBaseFromHost = (): string => {
	const { protocol, host } = window.location;
	const [subdomain, ...rest] = host.split('.');
	const envMatch = subdomain.match(/-(dev|staging)$/);
	const envPrefix = envMatch ? `${envMatch[1]}.` : '';
	return `${protocol}//${envPrefix}${rest.join('.') || host}`;
};

export const landingBase = (): string =>
	(process.env.REACT_APP_LANDING_URL || landingBaseFromHost()).replace(
		/\/$/,
		'',
	);

export const landingUrl = (path: string): string => {
	const base = landingBase();
	const locale = landingLocale();
	const localized = LANDING_LOCALIZED_PATHS[path]?.[locale] ?? path;

	if (locale === 'en') return `${base}${localized}`;
	return `${base}/${locale}${localized === '/' ? '' : localized}`;
};
